// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutSharedStyles } from "@sc/App/SharedStyles/CheckoutSharedStyles";
import { onePageCheckoutConfirmationShippingStyles } from "@sc/App/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationShipping";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutConfirmationShippingStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 135px;
        row-gap: 24px;
    `,
};
onePageCheckoutConfirmationShippingStyles.title = {
    ...checkoutSharedStyles.sectionTitle,
};
onePageCheckoutConfirmationShippingStyles.shippingMethodWrapper = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
onePageCheckoutConfirmationShippingStyles.dateWrapper = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};
onePageCheckoutConfirmationShippingStyles.shipOnComplete = {
    size: 14,
    lineHeight: "22px",
};
